import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [NgClass],
})
export class TooltipComponent {
  @Input() public position: 'br' | 'bl' | 'tr' | 'tl' = 'br';
  @Input() public isShort: boolean = false;
}
